<template>
  <el-form :model="form" label-width="100px">
    <el-form-item label="QR Code" prop="qrcode">
      <qrcode-vue :value="url" :size="128" />
    </el-form-item>
    <el-form-item label="URL" prop="url">
      <el-input
        v-model="url"
        readonly
        placeholder="Please enter URL"
        class="w-full"
      >
        <template #append>
          <el-tooltip content="Copy URL" placement="top">
            <el-button
              icon="el-icon-document-copy"
              @click="copyUrl"
              type="primary"
              size="mini"
            />
          </el-tooltip>
          <el-tooltip content="Open in new tab" placement="top">
            <el-button
              icon="el-icon-link"
              @click="openInNewTab"
              type="success"
              size="mini"
            />
          </el-tooltip>
        </template>
      </el-input>
    </el-form-item>
    <el-form-item label="Access Code" prop="accessCode">
      <el-input
        v-model="accessCode"
        placeholder="Please enter access code"
        class="w-full"
        clearable
      >
        <template #append>
          <el-tooltip content="Generate random code" placement="top">
            <el-button
              icon="el-icon-refresh"
              @click="generateAccessCode"
              type="primary"
              size="mini"
            />
          </el-tooltip>
          <el-tooltip
            content="Clear code: users can't visit the agent using code"
            placement="top"
          >
            <el-button
              icon="el-icon-close"
              @click="setCodeToNull"
              type="primary"
              size="mini"
            />
          </el-tooltip>
          <el-tooltip content="Copy code" placement="top">
            <el-button
              icon="el-icon-document-copy"
              @click="copyCode"
              type="primary"
              size="mini"
            />
          </el-tooltip>
        </template>
      </el-input>
    </el-form-item>
    <span class="flex flex-row justify-end">
      <el-button @click="handleCancel">Close</el-button>
      <!-- Save 按钮已删除，自动提交密码修改 -->
    </span>
  </el-form>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import copy from "copy-to-clipboard";
import { addOrUpdateAgent } from "@/api";

export default {
  name: "AiAgentShareSettings",
  components: {
    QrcodeVue,
  },
  emits: ["input", "confirm", "cancel"],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    accessCode: {
      get() {
        return this.form.config.access_code || "";
      },
      set(value) {
        this.$set(this.form.config, "access_code", value);
      },
    },
    url() {
      const base = process.env.VUE_APP_AGENT_API_URL_BASE || "";
      const target = new URL("#/agents/simple", base);
      target.search = new URLSearchParams({
        agentId: this.form.agent_id || "",
      }).toString();
      return target.toString();
    },
  },
  data() {
    const me = this;
    const form = {};
    Object.assign(form, JSON.parse(JSON.stringify(me.value)));
    // 确保form.config存在
    if (!form.config || typeof form.config !== "object") {
      form.config = {};
    }
    return {
      form,
      uploading: false,
      passwordChangeTimeout: null, // 防抖定时器
    };
  },
  watch: {
    accessCode() {
      // 用户修改密码时自动提交，1秒防抖
      if (this.passwordChangeTimeout) {
        clearTimeout(this.passwordChangeTimeout);
      }
      this.passwordChangeTimeout = setTimeout(() => {
        this.handleConfirm();
      }, 1000);
    },
  },
  methods: {
    setCodeToNull() {
      this.accessCode = null;
    },
    copyUrl() {
      if (copy(this.url)) {
        this.$message.success("URL copied to clipboard");
      } else {
        this.$message.error("Copy failed");
      }
    },
    copyCode() {
      if (copy(this.accessCode)) {
        this.$message.success("Access code copied to clipboard");
      } else {
        this.$message.error("Copy failed");
      }
    },
    openInNewTab() {
      window.open(this.url, "_blank");
    },
    generateAccessCode() {
      this.accessCode = Math.random().toString(36).slice(-6);
    },
    async handleConfirm() {
      const me = this;
      try {
        me.uploading = true;
        await addOrUpdateAgent(me.form);
      } finally {
        me.uploading = false;
      }
    },
    handleCancel() {
      const me = this;
      if (me.passwordChangeTimeout) {
        me.$emit("confirm", me.form);
      }
      me.$emit("cancel");
    },
  },
};
</script>
